import React, { Component } from "react";
import { post } from "aws-amplify/api";

export default class Settings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false
    };
  }

  billUser(details) {
    return post({
      apiName: "notes",
      path: "/billing",
      options: {
        body: details
      }
    });
  }

  render() {
    return (
      <div className="Settings">
      </div>
    );
  }
}
